import React, { useContext, useEffect, useState } from "react";
import AppContainer from "../Structure/AppContainer";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import Select from "react-select";
import ajaxProject from "../../util/remote/ajaxProject";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import ajaxUser from "../../util/remote/ajaxUser";
function ManualLedgerEntryCreate(props) {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [projectID, setProjectID] = useState("");
  const [LedgerID_credited, setLedgerID_credited] = useState("");
  const [LedgerID_debited, setLedgerID_debited] = useState("");
  const [description, setDescription] = useState("");
  const [cost_item, setCost_item] = useState("");
  const [date, setDate] = useState("");
  const [reciever, setReciever] = useState("");
  const [employee, setEmployee] = useState("");
  const [voucher_no, setVoucher_no] = useState("");
  const [trans_type] = useState("manual_ledgers");
  const [Supplier_ivoice_reff, setSupplier_ivoice_reff] = useState([]);
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState(0);
  // ✅ unified ledgers
  const [ledgers, setLedgers] = useState([]);
  const [supinvoices, setISupinvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [cost_allocations, setCost_allocations] = useState([]);
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);
  // ================= FETCH FUNCTIONS =================
  const getLedgers = async () => {
    try {
      const res = await ajaxAccounting.getALlLedgersMinData();
      if (res.status === "OK") {
        setLedgers(res.details); // ✅ FIXED
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching ledgers.");
    }
  };
  const getsupplierInvoices = async () => {
    const res = await ajaxAccounting.getSupplierInvoiceReferences();
    if (res.status === "OK") {
      setISupinvoices(res.details);
      setFilteredInvoices(res.details);
    }
  };
  const getEmployees = async () => {
    const res = await ajaxUser.getUsersMinimal_data();
    if (res.status === "OK") {
      setEmployees(res.details);
    }
  };
  const getProjects = async () => {
    const res = await ajaxProject.getProjectsMinnimalDataCliented();
    if (res.status === "OK") {
      setProjects(res.details);
    }
  };
  const getCost_Allocations = async () => {
    const res = await ajaxAccounting.getAllcostAllocations_min_data();
    if (res.status === "OK") {
      setCost_allocations(res.details);
    }
  };
  useEffect(() => {
    getLedgers();
    getsupplierInvoices();
    getProjects();
    getEmployees();
    getCost_Allocations();
  }, []);
  // ================= HANDLERS =================
  const handleLedgerChanging = (e) => {
    if (!e) return;
    setLedgerID_debited(e.id);
  };
  const resetForm = () => {
    setProjectID("");
    setAmount("");
    setCost_item("");
    setLedgerID_credited("");
    setLedgerID_debited("");
    setDescription("");
    setVoucher_no("");
    setReciever("");
    setSupplier_ivoice_reff([]);
  };
  const handleAdd = async (e) => {
    e.preventDefault();
    if (
      !LedgerID_credited ||
      !LedgerID_debited ||
      !amount ||
      !date ||
      LedgerID_credited === LedgerID_debited
    ) {
      toast.error("Fill all required fields and ensure ledgers are different");
      return;
    }
    if (
      Supplier_ivoice_reff.length > 0 &&
      parseFloat(amount) > totalInvoiceAmount
    ) {
      toast.error("Amount exceeds invoice total");
      return;
    }
    setLoading(true);
    const data = {
      folioID: "",
      amount: amount,
      projectID: projectID,
      LedgerID_debited: LedgerID_debited,
      LedgerID_credited: LedgerID_credited,
      cost_item: cost_item,
      date: date,
      reciever: reciever,
      employee: employee,
      created_by: userId,
      trans_type: trans_type,
      description: description,
      Supplier_ivoice_reffs: "",
      voucher_no: voucher_no,
      invoice_reff: "",
    };
    const res = await ajaxAccounting.CreatePaymentVoucher(data);
    setLoading(false);
    if (res.status === "OK") {
      toast.success(res.message);
      props.function();
      resetForm();
    } else {
      toast.error(res.message);
    }
  };
  // ================= UI =================
  return (
    <div>
      <Toaster />
      <div className="card">
        <div className="card-body">
          <h6>Manual Ledger Control</h6>
          <form onSubmit={handleAdd}>
            <div className="row">
              {/* Project */}
              <div className="col-md-3">
                <label>Project </label>
                <Select
                  options={projects}
                  getOptionLabel={(o) => o.project_name}
                  getOptionValue={(o) => o.id}
                  onChange={(e) => setProjectID(e.id)}
                />
              </div>
              {/* Debit */}
              <div className="col-md-4">
                <label>Debit *</label>
                <Select
                  options={ledgers.filter((l) => l.id !== LedgerID_credited)}
                  getOptionLabel={(o) => o.name}
                  getOptionValue={(o) => o.id}
                  onChange={handleLedgerChanging}
                />
              </div>
              {/* Credit */}
              <div className="col-md-4">
                <label>Credit *</label>
                <Select
                  options={ledgers.filter((l) => l.id !== LedgerID_debited)}
                  getOptionLabel={(o) => o.name}
                  getOptionValue={(o) => o.id}
                  onChange={(e) => setLedgerID_credited(e.id)}
                />
              </div>
              {/* Amount */}
              <div className="col-md-4">
                <label>Amount *</label>
                <input
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="form-control"
                />
              </div>
              {/* Date */}
              <div className="col-md-4">
                <label>Date *</label>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="form-control"
                />
              </div>
              {/* Description */}
              <div className="col-md-12">
                <label>Description</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
            <button disabled={loading} className="btn btn-success mt-3">
              {loading ? "Saving..." : "Save Ledger entry"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
export default ManualLedgerEntryCreate;
